<template>
  <div>
    <!-- HEADER WITH MAINNAV: CONTACT-, WEBSITE- AND SERVICE-NAVIGATION -->

    <header>
      <div>
        <MenuMain />
      </div>
    </header>

    <!-- ASIDE LEFT - CONTENT NAV -->

    <ContainerFlex>
      <template slot="aside-left">
        <CategoriesLeft />
      </template>

      <!-- CENTER - MAIN CONTENT -->

      <template slot="main-content">
        <!-- PRODUCT DESSCRIPTION -->

        <ProductDetail class="mb-4" sale :product="product" />

        <div
          class="flex justify-start lg:justify-end mx-4 lg:mx-0 mb-4 w-auto bg-grey-lighter rounded-sm"
        >
          <SafeCheckout class="w-full" />
        </div>

        <div class="p-6 mx-4 lg:mx-0 mb-4 bg-grey-lighter rounded-sm">
          <Paragraph class="wysiwyg-shop">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="product.content" />
          </Paragraph>

          <Paragraph
            v-if="
              product.accessorie_products &&
              product.accessorie_products.length > 0
            "
            class="mt-5"
          >
            <h3>Zubehör</h3>
            <div
              v-for="accessorie in product.accessorie_products"
              :key="accessorie.id"
              class="-mt-4 mb-2"
            >
              <nuxt-link tag="a" :to="accessorie.url">
                {{ accessorie.title }}
              </nuxt-link>
            </div>
          </Paragraph>
        </div>

        <div
          v-if="product.delivery_content"
          class="p-6 mx-4 lg:mx-0 mb-4 bg-grey-lighter rounded-sm"
        >
          <Paragraph>
            <h3>Im Lieferumfang enthalten</h3>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="wysiwyg-shop" v-html="product.delivery_content" />
          </Paragraph>
        </div>

        <!-- PDF DOWNLOAD -->

        <div
          v-if="product.files && product.files.length > 0"
          class="px-6 pt-6 pb-3 mx-4 lg:mx-0 mb-0 lg:mb-4 bg-grey-lighter rounded-sm"
        >
          <Paragraph>
            <h3>Downloads</h3>
            <PdfDownload
              v-for="(file, index) in product.files"
              :key="index"
              class="mb-6 mr-2"
              :file="file"
            >
              {{ file.description }}
            </PdfDownload>
          </Paragraph>
        </div>

        <div
          v-if="product.youtube_links && product.youtube_links.length > 0"
          class="px-6 pt-6 pb-3 mx-4 lg:mx-0 mb-0 lg:mb-4 bg-grey-lighter rounded-sm"
        >
          <Paragraph>
            <h3>Videos</h3>

            <youtube
              v-for="(link, index) in product.youtube_links"
              :key="index"
              :link="link"
            />
          </Paragraph>
        </div>

        <ProductsPreview
          class="lg:hidden"
          :products="product.similar_products"
        />
        <portal to="above-locations">
          <ProductsPreview
            class="hidden lg:block"
            full-width
            :products="product.similar_products"
          />
        </portal>
      </template>

      <!-- ASIDE RIGHT - CONTACT -->

      <template slot="aside-right">
        <AsideRight :coworker="product.consulter" />
      </template>
    </ContainerFlex>

    <!-- TRUST BANNER -->

    <TrustBanner />

    <!-- MENU SERVICE -->

    <div class="bg-grey-light">
      <Container class="py-13">
        <MenuService class="-mx-2 wow fadeIn" />
      </Container>
    </div>
  </div>
</template>

<script>
import MenuMain from '~/components/menu/MenuMain'

import Container from '~/components/layoutelements/Container'
import ContainerFlex from '~/components/layoutelements/ContainerFlex'
import CategoriesLeft from '~/components/layoutelements/CategoriesLeft'
import AsideRight from '~/components/layoutelements/AsideRight'
import ProductDetail from '~/components/sections/ProductDetail'
import Paragraph from '~/components/Paragraph'
import SafeCheckout from '~/components/SafeCheckout'
import TrustBanner from '~/components/sections/TrustBanner'
import MenuService from '~/components/menu/MenuService'
import PdfDownload from '~/components/PdfDownload'
import ProductsPreview from '~/components/ProductsPreview'

export default {
  components: {
    MenuMain,
    Container,
    ContainerFlex,
    CategoriesLeft,
    AsideRight,
    ProductDetail,
    Paragraph,
    SafeCheckout,
    TrustBanner,
    MenuService,
    PdfDownload,
    ProductsPreview,
  },
  async asyncData({ route, $axios, error }) {
    const result = await $axios.$get(route.path).catch((e) => {
      error({
        statusCode: (e.response && e.response.status) || 404,
        message: e.message,
      })
    })
    return { product: result }
  },
  head() {
    return {
      title:
        this.product.meta.title +
        ' | ' +
        this.product.brand.name +
        ' |' +
        'Media-Line',
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.product.meta.description,
        },
      ],
    }
  },
}
</script>
